import { push } from 'react-router-redux';
import routes from '../../configs/routes';
import { ReduxDispatch } from '../Action';
import { Client } from '../client/Client';
import ClientsAction from '../client/ClientsAction';
import { Order } from '../order/Order';
import OrdersAction from '../order/OrdersAction';

// Only the fields edited in the buyer modify form are submitted. Sending the
// whole order object would overwrite status flags (e.g. isPackaged) with
// stale values captured when the page was loaded.
export type BuyerModifyFormBody = Pick<
  Order,
  | 'id'
  | 'dueDate'
  | 'welcomeCall'
  | 'generalMessage'
  | 'valuationMessageFromBuyer'
  | 'tellerMessageFromBuyer'
  | 'client'
>;

export default class BuyerModifyAction {
  public static onSubmit(body: BuyerModifyFormBody) {
    return (dispatch: ReduxDispatch) => {
      if (!body.client) throw new Error('Missing client');
      const orderRequestBody = { ...body };
      const clientRequestBody = body.client;
      delete orderRequestBody.client;
      const requests: Promise<Client | Order>[] = [];
      requests.push(dispatch(OrdersAction.update(body.id, orderRequestBody)));
      requests.push(dispatch(ClientsAction.update(clientRequestBody.id, clientRequestBody)));
      Promise.all(requests).then(() => {
        dispatch(push(routes.BUYER.MODIFY_ORDERS_INDEX));
      });
    };
  }
}
